<template>
  <div class="mb-test-with-points">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: startGameConfig.mainImage.width + 'px' || 1920 + 'px',
        height: startGameConfig.mainImage.height + 'px' || 1080 + 'px',
        top: startGameConfig.mainImage.pos.y + 'px' || 0 + 'px',
        left: startGameConfig.mainImage.pos.y + 'px' || 0 + 'px',
      }"
    />
    <div class="main-box">
      <div :key="'test-with-points-' + index" v-for="(it, index) in items">
        <img :src="giveMeImagePlease(it.src)" :style="{ width: it.width + 'px' }" v-if="currentImg == index" />
      </div>
    </div>
    <div class="test-with-points-input">
      <input :maxlength="startGameConfig.maxLength" v-model="currentValue" @input="isItGoodOrNo()" />
    </div>
    <div class="mb-test-with-points-points-box">
      <div class="point-box-left">
        <div class="top">
          <img :src="giveMeImagePlease(startGameConfig.icons.positive)" />
        </div>
        <div class="bot">
          <p>{{ points.positive }}</p>
        </div>
      </div>
      <div class="point-box-right">
        <div class="top"><img :src="giveMeImagePlease(startGameConfig.icons.negative)" /></div>
        <div class="bot">
          <p>{{ points.negative }}</p>
        </div>
      </div>
    </div>
    <mb-audio-in-game
      :key="data.top + data.left + 'audio' + index"
      v-for="(data, index) in startGameConfig.mbAudioItemData"
      :item-data="data"
    ></mb-audio-in-game>
  </div>
</template>
<script>
import { Howler } from 'howler';
import defaultMixin from '../../mixins/defaultMixin';
import mbAudioInGame from '../../../MbAudioModal/MbAudioInGame';
export default {
  name: 'mb-test-with-points',
  components: { mbAudioInGame },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      currentImg: 0,
      points: {
        positive: 0,
        negative: 0,
      },
      currentValue: '',
      audio: null,
      status: false,
      canIPlay: true,
      items: [],
      curtain: [],
      openItem: [],
      fieldImg: [],
      currentField: 0,
      canICheck: true,
      audioNegative: null,
      audioPositive: null,
      canIPlayASong: true,
    };
  },
  created() {},
  beforeMount() {
    this.init();
  },
  mounted() {},
  methods: {
    isItGoodOrNo() {
      if (this.canICheck) {
        if (this.currentValue.length > 0) {
          let val = this.currentValue;
          this.canICheck = false;
          if (this.currentImg != -1) {
            if (this.items[this.currentImg].correct.length == val.length) {
              setTimeout(() => {
                console.log(this.items[this.currentImg].correct);
                console.log(this.currentValue);
                if (this.items[this.currentImg].correct == val) {
                  console.log('yeah');
                  this.points.positive++;
                  this.checkSound(true);
                } else {
                  this.points.negative++;
                  this.checkSound(false);
                }
                if (this.currentImg + 1 != this.items.length) {
                  this.currentValue = '';
                  this.currentImg++;
                } else {
                  this.currentValue = '';
                  this.currentImg = -1;
                  console.log('endOfGame');
                  this.$store.dispatch('checkGame');
                }
                this.canICheck = true;
              }, 500);
            }
          }
        }
      }
    },
    checkSound(status) {
      if (status) {
        if (this.audioPositive) {
          if (this.canIPlayASong) {
            this.audioPositive.play();
          } else {
            this.audioPositive.stop();
            if (this.audioNegative) {
              this.audioNegative.stop();
            }
            this.audioPositive.play();
          }
        }
      } else {
        if (this.audioNegative) {
          if (this.canIPlayASong) {
            this.audioNegative.play();
          } else {
            this.audioNegative.stop();
            if (this.audioPositive) {
              this.audioPositive.stop();
            }
            this.audioNegative.play();
          }
        }
      }
    },
    checkGameAction() {
      if (this.startGameConfig.pass) {
        if (this.points.positive > this.startGameConfig.pass) {
          return true;
        }
      } else {
        if (this.points.positive > 5) {
          return true;
        } else return false;
      }
    },
    init() {
      let item = this.startGameConfig.questions;
      if (this.startGameConfig.audio.positive) {
        this.audioPositive = new Howl({
          src: this.giveMeImagePlease(this.startGameConfig.audio.positive),
          autoplay: false,
          loop: false,
          volume: 0.5,
          onend: () => {
            this.canIPlayASong = true;
          },
          onstop: () => {
            this.canIPlayASong = true;
          },
          onplay: () => {
            this.canIPlayASong = false;
          },
        });
      }
      if (this.startGameConfig.audio.negative) {
        this.audioNegative = new Howl({
          src: this.giveMeImagePlease(this.startGameConfig.audio.negative),
          autoplay: false,
          loop: false,
          volume: 0.5,
          onend: () => {
            this.canIPlayASong = true;
          },
          onstop: () => {
            this.canIPlayASong = true;
          },
          onplay: () => {
            this.canIPlayASong = false;
          },
        });
      }
      this.shuffle(item);
      let pick;
      if (this.startGameConfig.pick) {
        pick = this.startGameConfig.pick;
      } else pick = item.length;
      for (let i = 0; i < pick; i++) {
        this.items.push(item[i]);
      }
    },
    setAudioConfig(src, volume) {
      this.audio = new Howl({
        src: this.giveMeImagePlease(src),
        autoplay: false,
        loop: false,
        volume: volume || 1,
        onend: () => {
          this.canIPlayASong = true;
          this.$store.commit('STATE_AUDIO', false);
        },
        onstop: () => {
          this.canIPlayASong = true;
          this.$store.commit('STATE_AUDIO', false);
        },
        onplay: () => {
          this.canIPlayASong = false;
        },
      });
    },
    startAudio() {
      this.audio.play();
    },
    stopAudio() {
      this.audio.stop();
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    resetGameAction() {
      this.currentValue = '';
      this.currentImg = 0;
      this.points.positive = 0;
      this.points.negative = 0;
      this.audio = null;
      this.status = false;
      this.canIPlay = true;
      this.items = [];
      this.curtain = [];
      this.openItem = [];
      this.init();
      this.canICheck = true;
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
  },
  destroyed() {},
  computed: {},
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 900px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.mb-test-with-points
  background-size: contain
  background-repeat: no-repeat
  position: relative
  top: $backgroundOffsetTop
  left: $backgroundOffsetLeft
  height: $backgroundHeight
  width: $backgroundWidth
  top: 50px
  display: flex
  justify-content: center
  align-items: center
  // flex-basis: 30%
  flex-wrap: wrap
  .test-with-points-input
    position: fixed
    bottom: 30px
    input
      width: 200px
      height: 120px
      text-align: center
      font-size: 65px
      font-family: 'Myriad Pro'
  .main-box
    width: 100%
    height: 100%
    position: absolute
    top: 0
    // background: red
    display: flex
    justify-content: center
    align-items: center
    // flex-basis: 30%
    flex-wrap: wrap
  .mb-test-with-points-points-box
    position: fixed
    bottom: 0
    left: 100px
    width: 180px
    height: 180px
    // background: red
    .point-box-left, .point-box-right
      width: 100%
      height: 50%
      display: inline-block
      position: absolute
      // background: blue
      .top, .bot
        width: 50%
        height: 100%
        position: absolute
        display: flex
        justify-content: center
        align-items: center
        // background: green
      .bot
        p
          color: white
          font-size: 65px
          font-weight: bold
          margin: 0
          font-family: 'Myriad Pro'
      .bot
        right: 0
      .top
        left: 0
    .point-box-left
      top: 0
    .point-box-right
      bottom: 0
  .memory-box
    .mb-memory-field
      display: inline-block
      margin: 5px
      cursor: pointer
      position: relative
      .memory-curtain
        position: absolute
        top: 0

.memory-fade-leave-active, .memory-fade-enter-active
  transition: all .3s linear
.memory-fade-leave-to, .memory-fade-enter
  opacity: 0
</style>
